import { useContext } from "react";
import {
  Card,
  Typography,
  Dialog,
  DialogContent,
  IconButton,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { PlannerContext } from "../../context/planner/PlannerContext";
import ToolSwitcher from "./tools/ToolSwitcher";

const ToolPanel = () => {
  const { selectedTool, isLoading, toolPanelOpen, closeToolPanel } =
    useContext(PlannerContext);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  // Hide the panel while the planner is loading
  if (isLoading) {
    return null;
  }

  const panelContent = selectedTool ? (
    <ToolSwitcher />
  ) : (
    <Typography>No tool selected</Typography>
  );

  // On mobile, render as a dialog
  if (isMobile) {
    return (
      <Dialog
        open={toolPanelOpen}
        onClose={closeToolPanel}
        fullWidth
        maxWidth="sm"
        PaperProps={{
          className: "tool-panel tool-panel--dialog",
          sx: {
            maxHeight: "90vh",
            display: "flex",
            flexDirection: "column",
          },
        }}
      >
        <IconButton
          onClick={closeToolPanel}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            zIndex: 1,
          }}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent
          sx={{
            pt: 4,
            pb: 0,
            px: {
              xs: 0,
              sm: 2,
            },
            display: "flex",
            flexDirection: "column",
            overflow: "hidden",
            flex: 1,
            minHeight: 0,
          }}
        >
          {panelContent}
        </DialogContent>
      </Dialog>
    );
  }

  // On desktop, render as a regular card
  return <Card className="tool-panel">{panelContent}</Card>;
};

export default ToolPanel;
